// One word (or visual-block marker) of speech-mark timing, as it arrives inside the
// multipart stream — one JSON object per application/json part. Mirrors the server's
// WordBoundariesItem and the iOS SpeechMarkup model.
export interface SpeechMarkup {
  // Milliseconds from the start of the current part's audio.
  time: number;
  // Character offsets into the server's clean text of the part. Fuzzy by design (the
  // server's clean text strips quotes and keeps table/pre text) — use for coarse block
  // bucketing only, never for exact positioning.
  start: number;
  // Exclusive.
  end: number;
  // The spoken word, punctuation-trimmed.
  text: string;
  // Absent for plain words; 'image' | 'table' mark visual blocks (demo items only today).
  type?: string;
  // Pairs with type: the content tag's id attribute.
  id?: string;
}

export function isSpeechMarkup(value: unknown): value is SpeechMarkup {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const markup = value as Record<string, unknown>;

  return (
    typeof markup['time'] === 'number' &&
    typeof markup['start'] === 'number' &&
    typeof markup['end'] === 'number' &&
    typeof markup['text'] === 'string'
  );
}
